import React from 'react'

import AppForm from 'components/Form/AppForm/AppForm'
import { collectPersonalIdForm } from 'FormDefinitions/CollectPersonalIdForm/CollectPersonalIdFormDefinition'
import useAppFormLogic from 'components/Form/AppForm/hooks/useAppFormLogic'

import './CollectPersonalIdPageStyles.scss'


const CollectPersonalIdPage = () => {

   const { handleCollectPersonalIdFormSubmitButtonClick } =  useAppFormLogic({ form: collectPersonalIdForm })

   return ( 
      <AppForm
         form={collectPersonalIdForm} 
         handleSubmitButtonClick={(e: React.SyntheticEvent) => handleCollectPersonalIdFormSubmitButtonClick(e)}  
      />
   )
}

export default CollectPersonalIdPage